/* eslint-disable */
import { memoize } from 'lodash/function';
import { QUESTION_TYPE } from 'new-ui/Components/QuestionRenderer/constants';
import { questionnaireApi } from 'modules/questionnaire/api';

// for question.type === OPTIONS_FROM_SERVER
const GETTER_BY_QUESTION_ID = {
  drugs_received: memoize((...args) => questionnaireApi.getQuestionOptions(...args), (...args) => JSON.stringify(args)),
  insurances: memoize((...args) => questionnaireApi.getQuestionOptions(...args), (...args) => JSON.stringify(args)),
};

export const loadOptions = async (q, condition, additionalParams) => {
  if (q.options?.radioOptions) q.radioOptions = q.options.radioOptions;
  if (q.options?.dropDownOptions) q.options = q.options.dropDownOptions;

  if (q.type !== QUESTION_TYPE.OPTIONS_FROM_SERVER) {
    return;
  }

  const getter = GETTER_BY_QUESTION_ID[q.id] ? GETTER_BY_QUESTION_ID[q.id] : questionnaireApi.getQuestionOptions;

  const r = await getter(
    q.id,
    condition,
    additionalParams,
  );
  q.options = window.structuredClone(r.data);

  if (!Array.isArray(q?.options)) {
    // should be invariant
    return;
  }

  q.options.forEach((o)=>{
    if (o.code) o.value = o.code;
    if (o.name) o.label = o.name;
  });
};
